import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * 회원(로그인) 전용 화면 가드 - 주문내역/주문상세처럼 로그인한 회원 본인 데이터를 보여주는
 * 화면에 쓴다. 지금까지는 비회원이 주소를 직접 입력해 들어와도(북마크, 로그아웃 후 뒤로가기 등)
 * 그대로 열려서 API 가 401 을 반환해 "불러오지 못했습니다" 같은 모호한 에러만 보였다 - 역할
 * 경계 정리(회원 전용 화면을 비회원에게 노출하지 않음) + UI 사용성 개선(에러 대신 로그인
 * 안내)을 위해 로그인 화면으로 먼저 안내한다. 실제 데이터 접근 제어는 서버가 최종 담당한다.
 */
export default function RequireMember({ children }) {
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
